// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kfg7iHv7Cqh1Js {
  height: 292px;
  margin-bottom: var(--ds-space-100, 8px);
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: it9cDi3uyHjmJO;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
@keyframes it9cDi3uyHjmJO {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .kfg7iHv7Cqh1Js {
    animation: none;
  }
}
.I24frmnLF2ExSo {
  height: 52px;
  margin-bottom: var(--ds-space-150, 12px);
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: it9cDi3uyHjmJO;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
@keyframes it9cDi3uyHjmJO {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .I24frmnLF2ExSo {
    animation: none;
  }
}
.Ic1YPqAUvRUZNW {
  height: 54px;
  margin-top: var(--ds-space-300, 24px);
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: it9cDi3uyHjmJO;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
@keyframes it9cDi3uyHjmJO {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .Ic1YPqAUvRUZNW {
    animation: none;
  }
}
.uam8mPhAPrbHJT {
  height: 40px;
  margin-top: var(--ds-space-100, 8px);
  margin-bottom: var(--ds-space-150, 12px);
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: it9cDi3uyHjmJO;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
@keyframes it9cDi3uyHjmJO {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .uam8mPhAPrbHJT {
    animation: none;
  }
}
.TEg7uSdusT_r9c {
  display: flex;
  flex-direction: column;
  row-gap: var(--ds-space-100, 8px);
}
.CFBiwR9PpDRPpO {
  height: 32px;
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  cursor: progress;
  background-origin: border-box;
  animation-name: it9cDi3uyHjmJO;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
@keyframes it9cDi3uyHjmJO {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .CFBiwR9PpDRPpO {
    animation: none;
  }
}
`, ""]);
// Exports
export var calendar = `kfg7iHv7Cqh1Js`;
export var shimmer = `it9cDi3uyHjmJO`;
export var dateField = `I24frmnLF2ExSo`;
export var dueReminderField = `Ic1YPqAUvRUZNW`;
export var dueReminderClarification = `uam8mPhAPrbHJT`;
export var buttons = `TEg7uSdusT_r9c`;
export var button = `CFBiwR9PpDRPpO`;
export default ___CSS_LOADER_EXPORT___;
